import type { AccountQualityEnum, AccountFragment } from "src/graphql/generated/types";

export function isTrusteeCouncilMember(account: AccountFragment): boolean {
  return account.__typename === "CoownerAccount" && account.isTrusteeCouncilMember;
}

export function decodeBase64UUID(
  encodedUUID: string
): {
  quality: AccountQualityEnum;
  customerId: string;
  accountId: string;
} {
  const decodedString = atob(encodedUUID);

  const decodedObject = JSON.parse(decodedString);

  return decodedObject;
}
